<template>
	<windmill-layout />
</template>

<script>
import WindmillLayout from '../WindmillLayout.vue';

export default {
	name: 'LayoutBackend',
	components: {
		WindmillLayout,
	},
};
</script>
